import { ContentfulCloudinaryImageComponent } from "../types/ContentfulTypes";

export class Icons {
  private icons: Record<string, ContentfulCloudinaryImageComponent | undefined>;
  private static instance: Icons;

  private constructor() {
    this.icons = {};
  }

  static getInstance(): Icons {
    if (!Icons.instance) {
      Icons.instance = new Icons();
    }
    return Icons.instance;
  }

  addToIconData(key: string, icon: ContentfulCloudinaryImageComponent) {
    const value = getIconInformation(icon);
    if (key && !Object.prototype.hasOwnProperty.call(this.icons, key)) {
      this.icons[key] = value;
    }
  }

  getIcon(key: string) {
    if (Object.prototype.hasOwnProperty.call(this.icons, key)) {
      return this.icons[key];
    }
    return undefined;
  }
}

export function getIconInformation(
  icon: ContentfulCloudinaryImageComponent
): ContentfulCloudinaryImageComponent | undefined {
  return icon;
}
